var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h3',[_vm._v(_vm._s(_vm.location.name))]),_c('iframe',{staticClass:"location",attrs:{"id":"gmap_canvas","src":'https://maps.google.fr/maps?q='+_vm.location.maps+'&ie=UTF8&z=12&iwloc=&output=embed',"frameborder":"0","scrolling":"no","marginheight":"0","marginwidth":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }